module.exports = __webpack_public_path__ + "img/q16.7e0ca413.jpeg";